import { render, staticRenderFns } from "./ConfirmWizard.vue?vue&type=template&id=134db358&scoped=true"
import script from "./ConfirmWizard.vue?vue&type=script&lang=js"
export * from "./ConfirmWizard.vue?vue&type=script&lang=js"
import style0 from "./ConfirmWizard.vue?vue&type=style&index=0&id=134db358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134db358",
  null
  
)

export default component.exports